import { useContext, useEffect, useState, useCallback } from "react";
import { Container, Grid } from "@material-ui/core";

import Loading from "../../../components/basics/Loading";
import Btn from "../../../components/buttons/Btn";
import HeaderModule from "../../../components/header/HeaderModule";
import { Margin } from "../../../theme/styles/Utils";

import { Line } from "./styles/ClassificacaoServico";
import { useHistory } from "react-router-dom";
import AccordionClassifPrincipal from "./children/AccordionClassifPrincipal";
import AccordionClassifCategorias from "./children/AccordionClassifCategorias";
import AccordionClassifReforma from "./children/AccordionClassifReforma";
import { ClassificacaoServicoContext } from "./contexts/ClassificacaoServicoContext";
import useClassificacaoServicoController from "./controllers/ClassificacaoServicoController";
import { GlobalVariables } from "../../../GlobalVariables";
import { QueryParamsContext } from "../../../context/QueryParamsContext";
import { findConfigurationV3 } from "../../../repositories/qerpapi/v3/ConfigurationRepository";

const ClassificacaoServicoCadastro = ({ location }) => {
  const { loading } = useContext(ClassificacaoServicoContext);
  const { queryParams } = useContext(QueryParamsContext);
  const [dadosConfiguration, setDadosConfiguration] = useState(null);

  const { handleSubmit, clear } = useClassificacaoServicoController();

  const { push } = useHistory();

  const back = () => {
    clear();
    push("listagem");
  };

  const { handleSetData } = useClassificacaoServicoController();

  useEffect(() => {
    handleSetData(location?.state?.id);
  }, [location?.state?.id, handleSetData]);

  const loadConfiguration = useCallback(async () => {
    if (!queryParams?.empresa_cnpj || !queryParams?.empresa_id) return;

    try {
      const configurationV3Response = await findConfigurationV3();
      setDadosConfiguration(
        configurationV3Response?.success ? configurationV3Response.data : null
      );
    } catch (error) {
      console.error("Erro ao buscar configuração:", error);
    }
  }, [queryParams?.empresa_cnpj, queryParams?.empresa_id]);

  useEffect(() => {
    loadConfiguration();
  }, [loadConfiguration]);

  return (
    <>
      <Loading open={loading} />
      <HeaderModule
        title="CADASTRO DE CLASSIFICAÇÃO DE SERVIÇOS"
        videoId={GlobalVariables.screenVideosIds.cadastroClassificacaoContratos}
      />
      <Margin top="100">
        <Container maxWidth="xl">
          <AccordionClassifPrincipal
            utilizaNovaNfse={dadosConfiguration?.utiliza_nova_nfse === 1}
          />
          <AccordionClassifReforma />
          <AccordionClassifCategorias />
          <Line container />
          <Line container spacing={2} justifyContent="flex-end">
            <Grid item>
              <Btn
                label="Voltar"
                hovercolor="darkred"
                bgcolor="tertiary"
                onClick={back}
              />
            </Grid>
            <Grid item>
              <Btn
                label="Salvar"
                onClick={() =>
                  handleSubmit(
                    false,
                    dadosConfiguration?.utiliza_nova_nfse === 1
                  )
                }
              />
            </Grid>
            <Grid item>
              <Btn
                label="Salvar e Novo"
                onClick={() =>
                  handleSubmit(
                    true,
                    dadosConfiguration?.utiliza_nova_nfse === 1
                  )
                }
              />
            </Grid>
          </Line>
        </Container>
      </Margin>
    </>
  );
};

export default ClassificacaoServicoCadastro;
